import { Component, OnInit } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { LocalDataSource } from 'ng2-smart-table';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';

import { MealItemsComponent } from '../MealItems/meal-items.component';
import {
  Meal,
  MealItem,
} from '../../../../../@core/interfaces/common/CalorieFriend/meal';
import { CalorieFriendFood } from '../../../../../@core/interfaces/common/CalorieFriend/food';
import { ServingSizeSelectionComponent } from './ServingSize/Selection/serving-size-selection.component';
import { BaseComponentCanDeactivate } from 'app/@auth/guards/changes.guard';
import { ConfirmMessageDialogComponent } from 'app/@components/confirm-message-dialog/confirm-message-dialog.component';

/**
 * Component for adding a new Meal with its meal items into the Day's Meals list.
 */
@Component({
  selector: 'app-meal',
  templateUrl: './meal.component.html',
  styleUrls: ['./meal.component.scss'],
})
export class MealComponent
  extends BaseComponentCanDeactivate
  implements OnInit {
  MealItemsLabel = 'Items';
  AddItemLabel = 'Add Item';
  DayID: number;
  TheMeal: Meal = null;
  ExistingMeals: Array<Meal> = null;
  ItemNameLabel = $localize`:@@Item:Item`;
  ImageLabel = 'Image';
  Qauntity = 'Quantity';
  AcceptLabel = 'Accept';
  BackLabel = 'Back';
  MealNameLabel = $localize`:@@Name:Name`;
  MealTimeLabel = $localize`:@@Time:Time`;
  ServingSizeSelectLabel = $localize`:@@Serving:Serving`;

  MealForm: FormGroup;
  MealDataSource: LocalDataSource;

  /**
   * Ng2 smart table settings for Meal items
   */
  MealTableSettings = {
    hideSubHeader: true,
    mode: 'external',
    actions: {
      columnTitle: $localize`:@@Actions:Actions`,
      position: 'right',
      add: false,
      edit: false,
    },
    delete: {
      deleteButtonContent:
        '<img src="assets/icons/trash-2-outline.svg" title="' +
        $localize`:@@Delete:Delete` +
        '" class="img-archive" width="24" height="24">',
    },
    columns: {
      friendlyName: {
        title: this.ItemNameLabel,
        type: 'string',
        filter: false,
        valuePrepareFunction: (init, data) => {
          return data.friendlyName;
        },
      },
      // imageURL: {
      //  title: this.ImageLabel,
      //  type: 'html', filter: false,
      //  valuePrepareFunction: (init, data) =>
      //  {
      //    return '<img src= ' + data.imageURL + '  />';
      //  }
      // },
      template: {
        title: this.ServingSizeSelectLabel,
        type: 'custom',
        renderComponent: ServingSizeSelectionComponent,
        filter: false,
        valuePrepareFunction: (value, row, cell) => {
          return {
            foodId: row.foodId,
            displayQuantitySelection: true,
            displayWithinGroup: false,
            isCustomFood: row.isCustomFood,
            AssociatedObject: row,
            AdjustHeight: false,
          };
        },
      },
      // quantity:
      // {
      //  title: this.Qauntity, type: 'custom',
      //  renderComponent: MealQuantityComponent,
      //  valuePrepareFunction: (value, row, cell) =>
      //  {
      //    return { id: row.foodId, quantity: row.quantity };
      //  },
      //  filter: false,
      //  onComponentInitFunction: (instance, row) =>
      //  {
      //    this.PrepQuantityUpdate(instance);
      //  }
      // }
    },
  };

  /** Meal ctor */
  constructor(
    private dialogService: NbDialogService,
    protected ref: NbDialogRef<MealComponent>,
    private fb: FormBuilder,
  ) {
    super(dialogService);
  }

  get MealName() {
    return this.MealForm.get('MealName');
  }
  get MealTime() {
    return this.MealForm.get('MealTime');
  }

  /**
   * Initializes the component.
   * Initializes the Meal form.
   */
  ngOnInit(): void {
    this.InitMealForm();

    if (this.TheMeal === null) {
      this.TheMeal = {
        id: null,
        name: '',
        time: '',
        items: null,
        dayID: this.DayID,
      };

      this.TheMeal.items = new Array<MealItem>();
    } else {
      this.MealForm.patchValue({
        MealName: this.TheMeal.name,
        MealTime: this.TheMeal.time,
      });

      if (this.MealDataSource !== null && this.MealDataSource !== undefined)
        this.MealDataSource.refresh();
      else this.MealDataSource = new LocalDataSource(this.TheMeal.items); // create the source
    }
  }

  /**
   * Sets the call back function for 'Quantity' change
   * @param instance
   */
  PrepQuantityUpdate(instance) {
    instance.SetCallBack(this, this.MealCountUpdate, 1);
  }

  /**
   * Updates the quantity of the food item.
   * @param This Self referencing object
   * @param id Food Item Id
   * @param quantity Food Quantity
   */
  MealCountUpdate(This, id: number, quantity: number) {
    if (
      This.TheMeal !== null &&
      This.TheMeal.items !== null &&
      This.TheMeal.items !== undefined
    ) {
      const FoodItem = This.TheMeal.items.find((obj) => obj.foodId === id);
      if (FoodItem !== null && FoodItem !== undefined) {
        FoodItem.quantity = quantity;
      }
    }
  }

  /**
   * Function to display MealItemsComponent to select food items to add to the current Meal.
   */
  SelectItems() {
    const ActiveFood = new Array<CalorieFriendFood>();

    for (const mealItem of this.TheMeal.items) {
      ActiveFood.push(mealItem);
    }

    this.dialogService
      .open(MealItemsComponent, {
        closeOnEsc: false,
        // context: { LoadedCurrentlyActiveFood: ActiveFood }
        context: { LoadedCurrentlyActiveFood: [] },
      })
      .onClose.subscribe((items) => {
       // this.UpdateSelectedItem(items);
        this.isDirty = true;
      });
  }

  /**
   * Function to update the items list of the Meal with the selected items.
   * @param items Meal Items list
   */
  UpdateSelectedItem(items) {
    if (items !== null && items !== undefined) {
      const HoldItems = null;
      const Quantity = 1;

      // if (this.TheMeal !== null && this.TheMeal.items !== null && this.TheMeal.items !== undefined)
      //   HoldItems = this.TheMeal.items;

      this.TheMeal.items; // = new Array<MealItem>();

      if (items !== null && items !== undefined) {
        for (const food of items) {
          // see if item is in list --
          // if (HoldItems !== null) {
          //   const Item = HoldItems.find(obj => obj.foodId === food.foodId);

          //   if (Item !== null && Item !== undefined)
          //     this.TheMeal.items.push(Item);
          //   else {
          //     food.id = null;
          //     // food.quantity = Quantity;
          //     food.mealID = this.TheMeal.id;
          //     this.TheMeal.items.push(food);
          //   }
          // }

          food.id = null;
          food.quantity = Quantity;
          food.mealID = this.TheMeal.id;
          this.TheMeal.items.push(food);
        }

        this.MealDataSource = new LocalDataSource(this.TheMeal.items); // create the source
      }
    }
  }

  /**
   * Function to check if the Meal form is valid for submit.
   */
  MealValid() {
    let MealsValid = true;

    if (
      this.TheMeal !== null &&
      this.TheMeal.items !== null &&
      this.TheMeal.items !== undefined &&
      this.TheMeal.items.length > 0
    ) {
      for (const item of this.TheMeal.items) {
        MealsValid = MealsValid && item.quantity > 0;
        if (!MealsValid) break;
      }
    } else MealsValid = false;

    if (MealsValid) {
      const CurrentTime = this.MealTime;
      MealsValid = CurrentTime.value !== '';

      if (MealsValid) {
        if (this.ExistingMeals !== null) {
          const Duplicate = this.ExistingMeals.find(
            (meal) => meal.name === this.MealName.value && meal !== this.TheMeal,
          );
          if (Duplicate !== null && Duplicate !== undefined) MealsValid = false;
        }

        if (MealsValid) {
          this.TheMeal.time = CurrentTime.value;
          this.TheMeal.name = this.MealName.value;
        }
      }
    }

    return MealsValid && this.MealForm.valid;
  }

  /**
   * Event handler of 'Accept' button's Click.
   */
  Accept() {
    if (this.MealValid()) {
      super.resetDirty();
      this.ref.close(this.TheMeal);
    }
  }

  /**
   * Event handler of 'Back' button's Click
   */
  Back() {
    super.back(() => {
      this.ref.close();
    });
  }

  /**
   * Initializes the Meal form.
   */
  InitMealForm() {
    this.MealForm = this.fb.group({
      MealName: this.fb.control('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(25),
      ]),
      MealTime: this.fb.control(''),
    });

    super.initForm(this.MealForm);

    // vconst CurrentTime = this.MealTime;
    // CurrentTime.value = "1:31 VPM";

    // this.MealForm.patchValue({
    //      MealTime: "1:31 VPM"
    //  });
  }

  /**
   * Event handler of the 'Delete' action of meal items list.
   * @param $event Event object.
   */
  onDelete($event) {
    this.dialogService
      .open(ConfirmMessageDialogComponent, {
        closeOnEsc: true,
        closeOnBackdropClick: true,
        context: { Message: 'Are you sure to delete this meal item?' },
      })
      .onClose.subscribe((result) => {
        if (result) {
          const UpdateItems = this.TheMeal.items.filter(
            (obj) => obj.foodId !== $event.data.foodId,
          );

          this.TheMeal.items = new Array<MealItem>();

          for (const food of UpdateItems) {
            this.TheMeal.items.push(food);
          }

          this.MealDataSource = new LocalDataSource(this.TheMeal.items); // update list
        }
      });
  }
}
